import {
  collection,
  addDoc,
  getDocs,
  query,
  orderBy,
  serverTimestamp,
} from "firebase/firestore";
import { db } from "../firebase/config";

/**
 * Salva un feedback utente nella collection "userFeedback".
 *
 * Schema del documento salvato:
 * {
 *   rating: number,        // 1-5 (obbligatorio)
 *   likes: string,         // "Cosa ti piace?" (opzionale)
 *   dislikes: string,      // "Cosa non ti piace?" (opzionale)
 *   suggestions: string,   // "Cosa vorresti?" (opzionale)
 *   userEmail: string,     // email dell'utente loggato (o "" se non disponibile)
 *   createdAt: serverTimestamp(),
 * }
 *
 * NOTA: la scrittura richiede una regola Firestore che consenta
 * `allow create` sulla collection userFeedback per utenti autenticati.
 *
 * @param {{rating:number, likes?:string, dislikes?:string, suggestions?:string, userEmail?:string}} data
 */
export async function submitFeedback({ rating, likes, dislikes, suggestions, userEmail }) {
  if (!rating || rating < 1 || rating > 5) {
    throw new Error("Il rating è obbligatorio (1-5 stelle).");
  }

  await addDoc(collection(db, "userFeedback"), {
    rating,
    likes: likes || "",
    dislikes: dislikes || "",
    suggestions: suggestions || "",
    userEmail: userEmail || "",
    createdAt: serverTimestamp(),
  });
}

/**
 * Legge tutti i feedback (collection "userFeedback") ordinati per data di
 * creazione (più recenti prima). Richiede regola Firestore che consenta
 * `allow read: if isAdmin()`.
 *
 * @returns {Promise<Array<{id:string, rating:number, likes:string, dislikes:string, suggestions:string, userEmail:string, createdAtMs:number|null}>>}
 */
export async function fetchFeedbacks() {
  const q = query(collection(db, "userFeedback"), orderBy("createdAt", "desc"));
  const snap = await getDocs(q);
  return snap.docs.map((d) => {
    const data = d.data();
    return {
      id: d.id,
      rating: typeof data.rating === "number" ? data.rating : 0,
      likes: data.likes || "",
      dislikes: data.dislikes || "",
      suggestions: data.suggestions || "",
      userEmail: data.userEmail || "",
      createdAtMs: data.createdAt?.toDate ? data.createdAt.toDate().getTime() : null,
    };
  });
}
